import {ALL_SHOWER_AREA_GROUPS, ALL_VANITY_AREA_GROUPS} from "../look/core/constants";

// Shared between UiPopupAIContentFeaturesAreas, aiFunctions, aiActions and aiAsyncActions.
// Lives in its own file (rather than the popup component) to avoid circular imports.
// `settingKey` is the aiRenderOptions/getAIGlobalSettings flag that says whether the area
// should be checked by default (see setDefaultAiFeatureAreasGroups).
export const FEATURE_AREAS: {featureArea: string, partIds: string[], settingKey: string}[] = [
  {featureArea: "Wet Area", partIds: [...new Set<string>(ALL_SHOWER_AREA_GROUPS)], settingKey: "aiAreasWetArea"},
  {featureArea: "Vanity Area", partIds: [...new Set<string>(ALL_VANITY_AREA_GROUPS)], settingKey: "aiAreasVanityArea"},
];
